<template>
  <div
    class="filter-tabs"
    :class="[
      $blockClass(blockClass, 'filter-tabs'),
      contentClass && contentClass,
      useFilters && 'filter-tabs--sticky'
    ]"
  >
    <div
      class="filter-tabs__container"
      role="tablist"
      :class="[
        $blockClass(blockClass, 'tabs-container')
      ]"
    >
      <div
        class="filter-tabs__header"
        :class="[
          $blockClass(blockClass, 'tabs-header'),
          !useFilters && 'filter-tabs__header--no-filter'
        ]"
      >
        <button
          v-if="useFilters"
          :aria-label="$string('accessibility.collection.change_layout')"
          type="button"
          class="filter-tabs__toggle"
          @click="handleLayoutToggle"
          v-text="$string('collection.layout')"
        />

        <h2
          v-if="!hideTitle"
          class="filter-tabs__title text-mobile-16-mobile"
          role="heading"
          v-text="tabTitle"
        />

        <button
          v-if="useFilters"
          :aria-label="filterTabLabel"
          type="button"
          class="filter-tabs__toggle"
          @click="handleShowFilters"
        >
          <span
            v-text="$string('collection.filter')"
          />
          <!--
            // @TODO: Get correct filter count instead of filter types
            <span
            v-if="selectedFiltersCount > 0"
            v-text="`&nbsp;(${selectedFiltersCount})`"
            />
          -->
        </button>
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Filter tabs (filter-tabs)
 * -----------------------------------------------------------------------------
 * Tabs containing filter lists.
 * @param {String} [blockClass] - String indicating block level BEM class.
 * @param {String} [tabTitle] - String determining layout icon to be displayed.
 * @param {Boolean} [hideTitle] - Boolean to check if title should be hidden
 * @param {Boolean} [useFilters] - Boolean to check if filter should be used
 * @param {Number} [selectedFiltersCount] - Number of selected filters
 *
 */

export default {
  name: 'FilterTabs',

  props: {
    blockClass: {
      type: String,
      default: '',
    },

    contentClass: {
      type: String,
      default: '',
    },

    tabTitle: {
      type: String,
      default: '',
    },

    hideTitle: {
      type: Boolean,
      default: false,
    },

    useFilters: {
      type: Boolean,
      default: true,
    },

    // selectedFiltersCount: {
    //   type: Number,
    //   default: 0,
    // },
  },

  emits: {
    'layout-toggled': () => true,
    'show-filters': () => true,
  },

  methods: {

    /**
     * Handles layout toggles.
     * Emits layout toggled event
     */
    handleShowFilters() {
      this.$emit('show-filters')
    },

    /**
     * Handles layout toggles.
     * Emits layout toggled event
     */
    handleLayoutToggle() {
      this.$emit('layout-toggled')
    },
  },
}
</script>
